/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetAllStatusesQueryVariables = Types.Exact<{
  search?: Types.StatusSearch;
}>;


export type GetAllStatusesQuery = {
  __typename?: 'Query',
  allStatuses?: Array<{
    __typename?: 'Status',
    id: number,
    description: string,
    type: Types.StatusType,
    cargoActionType?: Types.CallType | null,
    color: string,
    statusOrder?: number | null,
    supplierRequired: boolean,
    skipperRequiredFillInSailingReport: boolean,
    skipperRequiredFillInWeightVolume: boolean,
    applyByCustomer: boolean,
    applyBySkipper: boolean,
    applyByTerminal: boolean,
    requireActualTime: Types.StatusActualTimeType,
    estimateType?: Types.StatusEstimateType | null,
    estimateRequirement: Types.StatusEstimateRequirement,
    shouldLoadOnTerminal: boolean,
    closedStatus: boolean,
    cancelledStatus: boolean,
    loadedStatus: boolean,
    dischargedStatus: boolean,
    finishedStatus: boolean,
    allowComment: boolean,
    allowSkipperComment: boolean,
    shouldUpdateJDE: boolean,
    isInProgress: boolean,
    voyageVisibleBySkipper: boolean,
    voyageVisibleByCreditor: boolean,
    voyageEditableBySkipper: boolean,
    voyageEditableByCreditor: boolean,
    callVisibleByLocationOwner: boolean,
    isRejectStatus: boolean,
    isAcceptStatus: boolean,
    notifySkippers: boolean,
    notifyShipManagers: boolean,
    notifyShipOwners: boolean,
    notifyOperators: boolean,
    notifyCustomers: boolean,
    notifyTerminals: boolean,
    isCustomerNominatingStatus: boolean,
    isSkipperNominatingStatus: boolean,
    includeInNominationExport: boolean,
    laytimeStartStatus: boolean,
    laytimeEndStatus: boolean,
    requireDocuments: boolean,
    showConfirmMessage: boolean,
    expiringStatus: boolean,
    isActionStatus: boolean,
    requireTanks: boolean,
    sendDocument?: {
      __typename?: 'SendDocumentStatus',
      enabled: boolean,
      type?: Types.SendDocumentType | null,
      target?: Types.DocumentTarget | null
    } | null,
    translations?: {
      __typename?: 'LanguageDescription',
      id: number,
      defaultValue?: string | null,
      descriptions: Array<{
        __typename?: 'TranslationKeyValuePair',
        key: string,
        value: string
      }>
    } | null,
    confirmMessages?: {
      __typename?: 'LanguageDescription',
      id: number,
      defaultValue?: string | null,
      descriptions: Array<{
        __typename?: 'TranslationKeyValuePair',
        key: string,
        value: string
      }>
    } | null,
    rules?: Array<{
      __typename?: 'Rule',
      id: number,
      ifFitsStatusFlow: boolean,
      ifNotAppliedBefore: boolean,
      ruleType: {
        __typename?: 'RuleType',
        name: Types.StatusRule
      },
      targetStatus: {
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        supplierRequired: boolean,
        description: string,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean
        } | null
      }
    }> | null,
    successiveStatuses: Array<{
      __typename?: 'Status',
      id: number,
      type: Types.StatusType,
      description: string,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean
    }>
  }> | null
};

export type GetStatusQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetStatusQuery = {
  __typename?: 'Query',
  status: {
    __typename?: 'Status',
    id: number,
    description: string,
    type: Types.StatusType,
    cargoActionType?: Types.CallType | null,
    color: string,
    statusOrder?: number | null,
    supplierRequired: boolean,
    skipperRequiredFillInSailingReport: boolean,
    skipperRequiredFillInWeightVolume: boolean,
    applyByCustomer: boolean,
    applyBySkipper: boolean,
    applyByTerminal: boolean,
    requireActualTime: Types.StatusActualTimeType,
    estimateType?: Types.StatusEstimateType | null,
    estimateRequirement: Types.StatusEstimateRequirement,
    shouldLoadOnTerminal: boolean,
    closedStatus: boolean,
    cancelledStatus: boolean,
    loadedStatus: boolean,
    dischargedStatus: boolean,
    finishedStatus: boolean,
    allowComment: boolean,
    allowSkipperComment: boolean,
    shouldUpdateJDE: boolean,
    isInProgress: boolean,
    voyageVisibleBySkipper: boolean,
    voyageVisibleByCreditor: boolean,
    voyageEditableBySkipper: boolean,
    voyageEditableByCreditor: boolean,
    callVisibleByLocationOwner: boolean,
    isRejectStatus: boolean,
    isAcceptStatus: boolean,
    notifySkippers: boolean,
    notifyShipManagers: boolean,
    notifyShipOwners: boolean,
    notifyOperators: boolean,
    notifyCustomers: boolean,
    notifyTerminals: boolean,
    isCustomerNominatingStatus: boolean,
    isSkipperNominatingStatus: boolean,
    includeInNominationExport: boolean,
    laytimeStartStatus: boolean,
    laytimeEndStatus: boolean,
    requireDocuments: boolean,
    showConfirmMessage: boolean,
    expiringStatus: boolean,
    isActionStatus: boolean,
    requireTanks: boolean,
    sendDocument?: {
      __typename?: 'SendDocumentStatus',
      enabled: boolean,
      type?: Types.SendDocumentType | null,
      target?: Types.DocumentTarget | null
    } | null,
    translations?: {
      __typename?: 'LanguageDescription',
      id: number,
      defaultValue?: string | null,
      descriptions: Array<{
        __typename?: 'TranslationKeyValuePair',
        key: string,
        value: string
      }>
    } | null,
    confirmMessages?: {
      __typename?: 'LanguageDescription',
      id: number,
      defaultValue?: string | null,
      descriptions: Array<{
        __typename?: 'TranslationKeyValuePair',
        key: string,
        value: string
      }>
    } | null,
    rules?: Array<{
      __typename?: 'Rule',
      id: number,
      ifFitsStatusFlow: boolean,
      ifNotAppliedBefore: boolean,
      ruleType: {
        __typename?: 'RuleType',
        name: Types.StatusRule
      },
      targetStatus: {
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        supplierRequired: boolean,
        description: string,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean
        } | null
      }
    }> | null,
    successiveStatuses: Array<{
      __typename?: 'Status',
      id: number,
      type: Types.StatusType,
      description: string,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean
    }>
  }
};

export type GetStatusesQueryVariables = Types.Exact<{
  search?: Types.StatusSearch;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetStatusesQuery = {
  __typename?: 'Query',
  statuses: {
    __typename?: 'StatusPage',
    totalElements: number,
    content: Array<{
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType
    }>
  }
};

export type GetStatusRuleTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStatusRuleTypesQuery = {
  __typename?: 'Query',
  ruleTypes: Array<{
    __typename?: 'RuleType',
    name: Types.StatusRule,
    sourceType: Types.StatusType,
    targetType: Types.StatusType
  }>
};

export type GetStatusSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStatusSettingsQuery = {
  __typename?: 'Query',
  statusSettings?: {
    __typename?: 'StatusSettings',
    charterDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    cargoDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    voyageDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    callDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    callVoyageInProgressDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    callAtaDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    callAtdDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    callAtnDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    callDtnDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    cargoPlannedDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    voyageOrderDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    afterDeclaringVoyage?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    declarationDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    declarationDeclared?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null,
    invoiceDefault?: {
      __typename?: 'Status',
      id: number,
      description: string,
      type: Types.StatusType,
      cargoActionType?: Types.CallType | null,
      color: string,
      statusOrder?: number | null,
      supplierRequired: boolean,
      skipperRequiredFillInSailingReport: boolean,
      skipperRequiredFillInWeightVolume: boolean,
      applyByCustomer: boolean,
      applyBySkipper: boolean,
      applyByTerminal: boolean,
      requireActualTime: Types.StatusActualTimeType,
      estimateType?: Types.StatusEstimateType | null,
      estimateRequirement: Types.StatusEstimateRequirement,
      shouldLoadOnTerminal: boolean,
      closedStatus: boolean,
      cancelledStatus: boolean,
      loadedStatus: boolean,
      dischargedStatus: boolean,
      finishedStatus: boolean,
      allowComment: boolean,
      allowSkipperComment: boolean,
      shouldUpdateJDE: boolean,
      isInProgress: boolean,
      voyageVisibleBySkipper: boolean,
      voyageVisibleByCreditor: boolean,
      voyageEditableBySkipper: boolean,
      voyageEditableByCreditor: boolean,
      callVisibleByLocationOwner: boolean,
      isRejectStatus: boolean,
      isAcceptStatus: boolean,
      notifySkippers: boolean,
      notifyShipManagers: boolean,
      notifyShipOwners: boolean,
      notifyOperators: boolean,
      notifyCustomers: boolean,
      notifyTerminals: boolean,
      isCustomerNominatingStatus: boolean,
      isSkipperNominatingStatus: boolean,
      includeInNominationExport: boolean,
      laytimeStartStatus: boolean,
      laytimeEndStatus: boolean,
      requireDocuments: boolean,
      showConfirmMessage: boolean,
      expiringStatus: boolean,
      isActionStatus: boolean,
      requireTanks: boolean,
      sendDocument?: {
        __typename?: 'SendDocumentStatus',
        enabled: boolean,
        type?: Types.SendDocumentType | null,
        target?: Types.DocumentTarget | null
      } | null,
      translations?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      confirmMessages?: {
        __typename?: 'LanguageDescription',
        id: number,
        defaultValue?: string | null,
        descriptions: Array<{
          __typename?: 'TranslationKeyValuePair',
          key: string,
          value: string
        }>
      } | null,
      rules?: Array<{
        __typename?: 'Rule',
        id: number,
        ifFitsStatusFlow: boolean,
        ifNotAppliedBefore: boolean,
        ruleType: {
          __typename?: 'RuleType',
          name: Types.StatusRule
        },
        targetStatus: {
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          supplierRequired: boolean,
          description: string,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean
          } | null
        }
      }> | null,
      successiveStatuses: Array<{
        __typename?: 'Status',
        id: number,
        type: Types.StatusType,
        description: string,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean
      }>
    } | null
  } | null
};

export type GetStatusChangesQueryVariables = Types.Exact<{
  search: Types.StatusChangeSearch;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetStatusChangesQuery = {
  __typename?: 'Query',
  statusChanges: {
    __typename?: 'StatusChangePage',
    totalElements: number,
    content: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>
  }
};

export type GetStatusChangesWithEntityQueryVariables = Types.Exact<{
  search: Types.StatusChangeSearch;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetStatusChangesWithEntityQuery = {
  __typename?: 'Query',
  statusChanges: {
    __typename?: 'StatusChangePage',
    totalElements: number,
    content: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      call?: {
        __typename?: 'Call',
        voyage: {
          __typename?: 'Voyage',
          cargoCharter?: {
            __typename?: 'SalesCharter',
            id: number,
            type: Types.CharterType,
            charterNumber: string
          } | null
        },
        cargos: Array<{
          __typename?: 'CargoAction',
          id: number,
          cargo: {
            __typename?: 'Cargo',
            id: number,
            containerNumber?: string | null,
            cargoNumber?: string | null,
            product?: {
              __typename?: 'Product',
              id: number,
              name: string,
              description?: string | null
            } | null
          }
        }>
      } | null,
      cargo?: {
        __typename?: 'Cargo',
        id: number,
        containerNumber?: string | null,
        cargoNumber?: string | null,
        charter?: {
          __typename?: 'SalesCharter',
          id: number,
          charterNumber: string
        } | null,
        product?: {
          __typename?: 'Product',
          id: number,
          name: string,
          description?: string | null
        } | null,
        voyage?: {
          __typename?: 'Voyage',
          cargoCharter?: {
            __typename?: 'SalesCharter',
            id: number,
            type: Types.CharterType,
            charterNumber: string
          } | null
        } | null,
        actions: Array<{
          __typename?: 'CargoAction',
          id: number,
          type: Types.CallType,
          call?: {
            __typename?: 'Call',
            id: number,
            pta?: number | null,
            location: {
              __typename?: 'Location',
              id: number,
              description: string,
              locationGroups: Array<{
                __typename?: 'Location',
                id: number,
                description: string,
                type: Types.LocationType
              }>
            }
          } | null
        }>
      } | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>
  }
};

export type StatusChangerCargoActionMeasurementChecksQueryVariables = Types.Exact<{
  voyageId?: Types.InputMaybe<Types.Scalars['Long']['input']>;
  callId?: Types.InputMaybe<Types.Scalars['Long']['input']>;
  cargoId?: Types.InputMaybe<Types.Scalars['Long']['input']>;
  cargoActionType?: Types.InputMaybe<Types.CallType>;
  onlyLoading?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type StatusChangerCargoActionMeasurementChecksQuery = {
  __typename?: 'Query',
  cargoActionMeasurementChecks: Array<{
    __typename?: 'CargoActionMeasurementCheck',
    checked: boolean,
    action: {
      __typename?: 'CargoAction',
      id: number,
      type: Types.CallType,
      weight?: number | null,
      volume?: number | null,
      location?: {
        __typename?: 'Location',
        id: number,
        code?: string | null,
        description: string
      } | null,
      call?: {
        __typename?: 'Call',
        id: number
      } | null,
      cargo: {
        __typename?: 'Cargo',
        id: number,
        cargoNumber?: string | null,
        containerNumber?: string | null,
        voyage?: {
          __typename?: 'Voyage',
          id: number,
          ship: {
            __typename?: 'Ship',
            id: number
          }
        } | null,
        product?: {
          __typename?: 'Product',
          id: number,
          name: string,
          description?: string | null
        } | null,
        consignor?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        consignee?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null
      },
      measurements: {
        __typename?: 'Measurements',
        locationWeight?: number | null,
        locationWeightUnit?: Types.WeightUnit | null,
        skipperWeight?: number | null,
        skipperWeightUnit?: Types.WeightUnit | null,
        locationVolume?: number | null,
        locationVolumeUnit?: Types.VolumeUnit | null,
        skipperVolume?: number | null,
        skipperVolumeUnit?: Types.VolumeUnit | null,
        ambientVolume?: number | null,
        relativeDensity?: number | null,
        productTemperature?: number | null,
        actualConsignor?: string | null,
        actualConsignee?: string | null,
        protest?: boolean | null
      }
    }
  }>
};

export type StatusChangerCargoTanksQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type StatusChangerCargoTanksQuery = {
  __typename?: 'Query',
  cargo?: {
    __typename?: 'Cargo',
    id: number,
    cargoNumber?: string | null,
    containerNumber?: string | null,
    product?: {
      __typename?: 'Product',
      id: number,
      name: string
    } | null,
    voyage?: {
      __typename?: 'Voyage',
      id: number,
      ship: {
        __typename?: 'Ship',
        id: number,
        tanks: Array<{
          __typename?: 'Tank',
          id: number
        }>
      }
    } | null,
    tanks: Array<{
      __typename?: 'Tank',
      id: number,
      position: Types.TankPosition,
      positionNumber: number,
      capacityM3?: number | null
    }>
  } | null
};


export const GetAllStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusSearch"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}}]} as unknown as DocumentNode<GetAllStatusesQuery, GetAllStatusesQueryVariables>;
export const GetStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}}]} as unknown as DocumentNode<GetStatusQuery, GetStatusQueryVariables>;
export const GetStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusSearch"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetStatusesQuery, GetStatusesQueryVariables>;
export const GetStatusRuleTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStatusRuleTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ruleTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"targetType"}}]}}]}}]} as unknown as DocumentNode<GetStatusRuleTypesQuery, GetStatusRuleTypesQueryVariables>;
export const GetStatusSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStatusSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charterDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyageDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callVoyageInProgressDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callAtaDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callAtdDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callAtnDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callDtnDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoPlannedDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyageOrderDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"afterDeclaringVoyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declarationDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declarationDeclared"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}}]} as unknown as DocumentNode<GetStatusSettingsQuery, GetStatusSettingsQueryVariables>;
export const GetStatusChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStatusChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChangeSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}}]} as unknown as DocumentNode<GetStatusChangesQuery, GetStatusChangesQueryVariables>;
export const GetStatusChangesWithEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStatusChangesWithEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChangeSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargoCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargoCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}}]} as unknown as DocumentNode<GetStatusChangesWithEntityQuery, GetStatusChangesWithEntityQueryVariables>;
export const StatusChangerCargoActionMeasurementChecksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StatusChangerCargoActionMeasurementChecks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cargoId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cargoActionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CallType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyLoading"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargoActionMeasurementChecks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"voyageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"callId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cargoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cargoId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cargoActionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cargoActionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"onlyLoading"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyLoading"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checked"}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoActionActuals"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cargoActionActuals"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWeight"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeight"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolume"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolume"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"ambientVolume"}},{"kind":"Field","name":{"kind":"Name","value":"relativeDensity"}},{"kind":"Field","name":{"kind":"Name","value":"productTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignor"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignee"}},{"kind":"Field","name":{"kind":"Name","value":"protest"}}]}}]}}]} as unknown as DocumentNode<StatusChangerCargoActionMeasurementChecksQuery, StatusChangerCargoActionMeasurementChecksQueryVariables>;
export const StatusChangerCargoTanksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StatusChangerCargoTanks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"tank"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tank"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"capacityM3"}}]}}]} as unknown as DocumentNode<StatusChangerCargoTanksQuery, StatusChangerCargoTanksQueryVariables>;